module.exports = __webpack_public_path__ + "img/pic2.60efc915.png";